import type { SVGProps } from "react";
import * as React from "react";
import { type iconSize, iconSizeVariants } from "@remi/types/icons";

type SvgIconProps = SVGProps<SVGSVGElement> & {
  size?: iconSize;
};
const StatusInProgress = ({ size = "sm", ...props }: SvgIconProps) => {
  props.width = iconSizeVariants[size];
  props.height = iconSizeVariants[size];
  return (
    <svg {...props} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8 4.99999C8 4.44771 7.54533 3.98717 7.01012 4.12341C5.27971 4.56392 4 6.1325 4 7.99999C4 9.86748 5.27971 11.4361 7.01012 11.8766C7.54533 12.0128 8 11.5523 8 11V4.99999Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 14C11.3137 14 14 11.3137 14 8C14 4.68629 11.3137 2 8 2C4.68629 2 2 4.68629 2 8C2 11.3137 4.68629 14 8 14ZM8 12.75C10.6234 12.75 12.75 10.6234 12.75 8C12.75 5.37665 10.6234 3.25 8 3.25C5.37665 3.25 3.25 5.37665 3.25 8C3.25 10.6234 5.37665 12.75 8 12.75Z"
        fill="currentColor"
      />
    </svg>
  );
};
export default StatusInProgress;
